import { createClient as createWSClient } from "graphql-ws";
import { getLocalStorage } from "./utils/LocalStorage.utils";
export const wsClient = createWSClient({
    url: import.meta.env.VITE_WEBSOCKER_URL || "ws://localhost:4000/graphql",
    connectionParams: () => {
        const idToken = getLocalStorage(`${import.meta.env.VITE_SESSION_PREFIX}-id-token`);
        const headers = {};
        if (idToken) {
            headers.Authorization = idToken;
        }
        return {
            headers
        };
    }
});
